export type FrontendNavigationItem =
    | "loyalty_card"
    | "loyalty_points"
    | "transactions"
    | "rewards"
    | "events"
    | "ticketshop"
    | "account"
    | "help"
    | "benefits"
    | "coupons"
    | "parking"
    | "advent_calendar"
    | "advent_calendar_my"
    | "advent_calendar_door";

export interface NavigationVisit {
    nav_item: FrontendNavigationItem;
    new: boolean;
    updated_at: string;
}

export const useNavigationVisitsStore = defineStore("navigationVisits", () => {
    const visits: Ref<{
        [NavigationItem: string]: NavigationVisit;
    } | null> = ref(null);

    const setVisits = (data: NavigationVisit[]) => {
        visits.value = data
            .map((visit) => ({ [visit.nav_item]: visit }))
            .reduce((acc, curr) => ({ ...acc, ...curr }), {});
    };

    const markVisited = (navItem: FrontendNavigationItem) => {
        if (visits.value?.[navItem]) {
            visits.value[navItem].new = false;
        }
    };

    return {
        visits,
        setVisits,
        markVisited,
    };
});
